import { ValidatorFn, Validators } from '@angular/forms';

function fieldDependencies(field: any): any {
  const raw = field?.fielddependencies;
  if (!raw) {
    return null;
  }
  if (typeof raw === 'object') {
    return raw;
  }
  try {
    return JSON.parse(String(raw));
  } catch {
    return null;
  }
}

/** Lista tipo prototipo (Obligatorio / Opcional). Sin la marca, el alta sigue con los botones Subir. */
export function isType53Checklist(field: any): boolean {
  return fieldDependencies(field)?.checklist === true;
}

export function isType53DocumentRequired(field: any, fileMeta: any): boolean {
  if (!isType53Checklist(field)) {
    return false;
  }
  if (fileMeta && fileMeta.required === false) {
    return false;
  }
  if (fileMeta && fileMeta.required === true) {
    return true;
  }
  return !!field?.required;
}

export function type53FileValidators(field: any, fileMeta: any): ValidatorFn[] {
  return isType53DocumentRequired(field, fileMeta) ? [Validators.required] : [];
}

/** El valor del checklist no se pudo leer. No se interpreta como "no falta nada". */
export const TYPE53_DOCS_INVALID = 'No se pudo validar la documentación requerida';

export function type53MissingDocumentsMessage(missing: string[]): string {
  if (missing.length === 1 && missing[0] === TYPE53_DOCS_INVALID) {
    return TYPE53_DOCS_INVALID + '.';
  }
  return 'Adjunta los documentos obligatorios: ' + missing.join(', ') + '.';
}

function parseJson(raw: any): { ok: true; value: any } | { ok: false } {
  if (typeof raw !== 'string') {
    return { ok: true, value: raw };
  }
  try {
    return { ok: true, value: JSON.parse(raw) };
  } catch {
    return { ok: false };
  }
}

function slotHasDocument(doc: any, fileMeta: any): boolean {
  if (!doc) {
    return false;
  }
  if (typeof File !== 'undefined' && doc.file instanceof File) {
    return true;
  }
  const savedName = doc.fileName != null ? String(doc.fileName).trim() : '';
  const catalogName = fileMeta?.name != null ? String(fileMeta.name).trim() : '';
  return savedName !== '' && savedName !== catalogName;
}

/**
 * Nombres de documentos obligatorios que no tienen archivo.
 * Lista vacía si el campo no es checklist o todavía no hay tipo de empresa.
 * Si el JSON no se puede leer, devuelve un aviso y no deja pasar el guardado.
 * Un archivo ya guardado cuenta: su fileName es el del archivo, no el del catálogo.
 */
export function missingType53Documents(field: any, value: any): string[] {
  if (!field || !isType53Checklist(field)) {
    return [];
  }
  const parsedValue = parseJson(value);
  if (!parsedValue.ok) {
    return [TYPE53_DOCS_INVALID];
  }
  const data = parsedValue.value;
  if (!data || data.tipoEmpresa == null || data.tipoEmpresa === '') {
    return [];
  }
  const parsedOptions = parseJson(field.values);
  if (!parsedOptions.ok || !Array.isArray(parsedOptions.value)) {
    return [TYPE53_DOCS_INVALID];
  }
  const tipo = parsedOptions.value.find((emp: any) =>
    String(emp?.id) === String(data.tipoEmpresa)
  );
  if (!tipo || !Array.isArray(tipo.files)) {
    return [TYPE53_DOCS_INVALID];
  }
  const docs = Array.isArray(data.documentos) ? data.documentos : [];
  return tipo.files
    .filter((file: any) => isType53DocumentRequired(field, file))
    .filter((file: any) => {
      const doc = docs.find((item: any) => String(item?.fileId) === String(file.id));
      return !slotHasDocument(doc, file);
    })
    .map((file: any) => file.name || 'Documento');
}
